module.exports = CHUI.Auth;